import Vue from 'vue'
import VueRouter from 'vue-router'
import Splashscreen from '../components/onboarding/Splashscreen'
import Startscreen from '../components/onboarding/Startscreen'
import Login from '../components/onboarding/Login'
import Verifikasi from "../components/onboarding/Verifikasi";
import SuccessLogin from "../components/onboarding/SuccessLogin";
import ForgotPassword from "../components/onboarding/ForgotPassword";
import ResetPassword from "../components/onboarding/ResetPassword";
import AkunLogin from "../components/onboarding/AkunLogin";
import Register from '../components/onboarding/Register'
import VerifikasiRegis from "../components/onboarding/VerifikasiRegis";
import FlowRegis1 from "../components/onboarding/FlowRegis1";
import SuccessRegis from "../components/onboarding/SuccessRegis";
import Coba from "../components/Coba";
import AkunRegister from "../components/onboarding/AkunRegister";
import HomeOutlet from "../components/onboarding/HomeOutlet";
import Dashboard from "../components/onboarding/Dashboard";
import DetailOutlet from "../components/onboarding/DetailOutlet";
import DetailOutletNonaktif from "../components/Outlet/Detail Outlet Nonaktif/DetailOutletNonaktif";
import DataOutlet from "../components/onboarding/DataOutlet";
import ProductionProcess from "../components/onboarding/ProductionProcess";
import ProductionActivity from "../components/onboarding/ProductionActivity";
import ProductionPlace from "../components/onboarding/ProductionPlace";
import AddOutlet from "../components/AddOutlet";
import SetProduction from "../components/production/SetProduction";
import DetailWorkshopSetprod from "../components/production/DetailWorkshopSetprod";
import TahapanSetProduksi from "../components/production/TahapanSetProduksi";
import DataWorkshopProduksi from "../components/production/DataWorkshopProduksi";
import CreateTahapanSetProd from "../components/production/CreateTahapanSetProd";
import TahapanDetailSetProd from "../components/production/TahapanDetailSetProd";
import Layanan from "../components/Layanan/Layanan";
import TambahLayanan from "../components/Layanan/TambahLayanan";
import EditLayanan from "../components/Layanan/EditLayanan";
import PengaturanLayanan from "../components/Outlet/Layanan/PengaturanLayanan";
import SnapService from "../components/Snap/SnapService";
import SnapCreate from "../components/Snap/SnapCreate";
import SnapEdit from "../components/Snap/SnapEdit";
import SetSnapService from "../components/Outlet/Layanan Snap/SetSnapService";
import DataRak from "../components/Rak/DataRak";
import CreateRak from "../components/Rak/CreateRak";
import EditRak from "../components/Rak/EditRak";
import DetailRak from "../components/Rak/DetailRak";
import SetRak from "../components/Outlet/Rak/SetRak";
import DataPerfume from "../components/onboarding/DataPerfume";
import TaxSetting from "../components/onboarding/TaxSetting";
import Nota from "../components/onboarding/Nota";
import NotaText from "../components/onboarding/NotaText";
import SetNota from "../components/Outlet/Nota/SetNota";
import Deposit from "../components/deposit/Deposit";
import TambahDeposit from "../components/deposit/TambahDeposit";
import EditDeposit from "../components/deposit/EditDeposit";
import SetDeposit from "../components/Outlet/Deposit/SetDeposit";
import EpaymentList from "../components/Epayment/EpaymentList";
import EpaymentCreate from "../components/Epayment/EpaymentCreate";
import EpaymentEdit from "../components/Epayment/EpaymentEdit";
import SetEpayment from "../components/Outlet/E-Payment/SetEpayment";
import AddWorkshop from "../components/AddWorkshop";
import SetTahapanWorkshop from "../components/onboarding/Create Workshop/SetTahapanWorkshop";
import DataWorkshop from "../components/onboarding/Create Workshop/DataWorkshop";
import ProductionWorkshop from "../components/onboarding/Create Workshop/ProductionWorkshop";
import DetailWorkshop from "../components/onboarding/Create Workshop/DetailWorkshop";
import DetailWorkshopNonaktif from "../components/Outlet/Detail Workshop Nonaktif/DetailWorkshopNonaktif";
import KaryawanList from "../components/Karyawan/KaryawanList";
import CreateStaff from "../components/Karyawan/CreateStaff";
import DataStaff from "../components/Karyawan/DataStaff";
import DataPekerjaan from "../components/Karyawan/DataPekerjaan";
import DataGaji from "../components/Karyawan/DataGaji";
import Karyawan from "../components/Karyawan/Karyawan";
import DetailKaryawan from "../components/Karyawan/DetailKaryawan";
import WorkSet from "../components/Karyawan/WorkSet";
import AkunSet from "../components/Karyawan/AkunSet";
import SalesSet from "../components/Karyawan/SalesSet";
import SallarySet from "../components/Karyawan/SallarySet";
import CategorySallary from "../components/Karyawan/CategorySallary";
import ActivationCommision from "../components/Karyawan/ActivationCommision";
import ListCommision from "../components/Karyawan/ListCommision";
import CreateCommision from "../components/Karyawan/CreateCommision";
import LogouPage from "../components/Karyawan/LogouPage";
import DetailAkun from "../components/Akun/DetailAkun";
import LoginOwnerWA from "../components/Akun/LoginOwnerWA";
import LoginOwnerEmail from "../components/Akun/LoginOwnerEmail";
import SetEmailOwner from "../components/Akun/SetEmailOwner";
import VerifikasiNomorLama from "../components/Akun/VerifikasiNomorLama";
import VerifikasiNomorBaru from "../components/Akun/VerifikasiNomorBaru";
import SuccessChangeWA from "../components/Akun/SuccessChangeWA";
import PusatBantuan from "../components/Akun/PusatBantuan";
import EditEmail from "../components/Akun/EditEmail";
import SuccessChangeEmail from "../components/Akun/SuccessChangeEmail";
import VerifikasiEmail from "@/components/Akun/VerifikasiEmail";
import CreatePassword from "../components/Akun/CreatePassword";
import SuccessChangePassword from "../components/Akun/SuccessChangePassword";
import AddPenggajian from "../components/AddPenggajian";
import Penggajian from "../components/penggajian/Penggajian"
import BayarGaji from "../components/penggajian/Faktur Gaji/BayarGaji"
import FakturGaji from "../components/penggajian/Faktur Gaji/FakturGaji"
import ListTanggungan from "../components/penggajian/Faktur Gaji/ListTanggungan"
import DetailKehadiran from "../components/penggajian/Faktur Gaji/DetailKehadiran"
import UbahAbsensi from "../components/penggajian/Faktur Gaji/UbahAbsensi"
import PreviewGaji from "../components/penggajian/Faktur Gaji/PreviewGaji"
import DetailPembayaran from "../components/penggajian/Faktur Gaji/DetailPembayaran"
import RiwayatPembayaran from "../components/penggajian/Riwayat Pembayaraan/RiwayatPembayaran"
import AddKasbon from "../components/penggajian/Kasbon/AddKasbon";
import ListKasbon from "../components/penggajian/Kasbon/ListKasbon"
import TambahKasbon from "../components/penggajian/Kasbon/TambahKasbon"
import BayarKasbon from "../components/penggajian/Kasbon/BayarKasbon"
import RiwayatCicilKasbon from "../components/penggajian/Kasbon/RiwayatCicilKasbon"
import DetailKasbon from "../components/penggajian/Kasbon/DetailKasbon";
import AddPotongan from "../components/penggajian/Potongan Gaji/AddPotongan";
import ListPotongan from "../components/penggajian/Potongan Gaji/ListPotongan"
import TambahPotonganx from "../components/penggajian/Potongan Gaji/TambahPotonganx"
import BayarPotonganx from "../components/penggajian/Potongan Gaji/BayarPotonganx"
import RiwayatCicilPotongan from "../components/penggajian/Potongan Gaji/RiwayatCicilPotongan"
import DetailPotonganx from "../components/penggajian/Potongan Gaji/DetailPotonganx";
import DetailPotonganCicilx from "../components/penggajian/Potongan Gaji/DetailPotonganCicilx";
import ListKomisix from "../components/penggajian/Komisi Penggajian/ListKomisix"
import CreateKomisi from "../components/penggajian/Komisi Penggajian/CreateKomisi";
import InputLayananSnap from "../components/Snap/InputLayananSnap"
import RekapAbsen from "../components/Karyawan/Absensi/RekapAbsen"
import DetailAbsen from "../components/Karyawan/Absensi/DetailAbsen"
import ImporAbsen from "../components/Karyawan/Absensi/ImporAbsen"
import PeriodeAbsen from "../components/Karyawan/Absensi/PeriodeAbsen"
import AddKomisiP from "../components/penggajian/Komisi Penggajian/AddKomisiP";
import EditKomisix from "../components/penggajian/Komisi Penggajian/EditKomisix";
import Notification from "../components/Dashboard/Notification";
import DataDashboard from "../components/Dashboard/DataDashboard";
import Ibos from "../components/ibos/Ibos";
import Backup2020 from "../components/ibos/Backup2020";
import backupLayanan from "../components/ibos/backupLayanan";
import backupDeposit from "../components/ibos/backupDeposit";
import Broadcast from "../components/ibos/broadcast";
import Rewind from "../components/ibos/Rewind";
import DebugApp from "../components/Akun/DebugApp";
import ActiveSession from "../components/Akun/ActiveSession.vue";
import SubscribeOwner from "../components/ibos/SubscribeOwner";

import PlaygroundInput from "@/views/playground/PlaygroundInput";
import PenyesuaianPaketEpayment from "@/modules/pengaturan-umum/views/PenyesuaianPaketEpayment";
import AnnouncementPage from "@/views/AnnouncementPage";
import BugTransaksi from "@/views/BugTransaksi";

import store from '../store'
import helpers from '../helpers/helpers'
import axios from 'axios'

Vue.use(VueRouter)

const requireAuth = {requireAuth: true};
const notRequireAuth = {requireAuth: false};

import SOInputPhoto from "@/so-components/global/input/SOInputPhoto";
const routes = [
	{
		path: '/pembenahan-transaksi',
		name: 'pembenahan_transaksi',
		component: BugTransaksi,
		meta: requireAuth,
	},
	{
		path: '/announcement-page',
		name: 'announcement_page',
		component: AnnouncementPage,
		meta: requireAuth,
	},
	{
		path: '/playground',
		name: 'playground',
		component: Coba,
		meta: requireAuth,
	},

	{
		path: '/',
		name: 'splashscreen',
		component: Splashscreen,
		meta: notRequireAuth
	},

	{
		path: '/startscreen',
		name: 'startscreen',
		component: Startscreen,
		meta: notRequireAuth
	},

	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: notRequireAuth
	},

	{
		path: '/register',
		name: 'register',
		component: Register,
		meta: notRequireAuth
	},

	{
		path: '/verifikasi',
		name: 'verifikasi',
		component: Verifikasi,
		meta: notRequireAuth
	},

	{
		path: '/verifikasiregis',
		name: 'verifikasiregis',
		component: VerifikasiRegis,
		meta: notRequireAuth,
		props: true,
	},

	{
		path: '/flowregis1',
		name: 'flowregis1',
		component: FlowRegis1
	},

	{
		path: '/successregis',
		name: 'successregis',
		component: SuccessRegis,
		meta: notRequireAuth
	},

	{
		path: '/successlogin',
		name: 'successlogin',
		component: SuccessLogin,
		meta: notRequireAuth
	},

	{
		path: '/forgotpassword/:type',
		name: 'forgotpassword',
		component: ForgotPassword,
		meta: notRequireAuth
	},

	{
		path: '/akunlogin',
		name: 'akunlogin',
		component: AkunLogin,
		meta: notRequireAuth
	},
	{
		path: "/akunregister",
		name: 'akunregister',
		component: AkunRegister,
		meta: notRequireAuth
	},
	{
		path: "/resetpassword/:code",
		name: 'resetpassword',
		component: ResetPassword,
		meta: localStorage.getItem("token") !== null ? requireAuth : null
	},

	{
		path: "/homeoutlet",
		name: 'homeoutlet',
		component: HomeOutlet,
		meta: requireAuth,
	},
	{
		path: "/dataoutlet",
		name: "dataoutlet",
		component: DataOutlet,
		meta: requireAuth
	},
	{
		path: "/productionprocess",
		name: "productionprocess",
		component: ProductionProcess,
		meta: requireAuth
	},
	{
		path: "/ProductionActivity",
		name: "productionactivity",
		component: ProductionActivity,
		meta: requireAuth
	},
	{
		path: "/ProductionPlace",
		name: "productionplace",
		component: ProductionPlace,
		meta: requireAuth
	},
	{
		path: "/AddOutlet",
		name: "addoutlet",
		component: AddOutlet,
		meta: {
			...requireAuth,
			accessKey: "outletWorkshop"
		}
	},
	{
		path: "/AddOutlet/:idoutlet",
		name: "addoutletwithid",
		component: AddOutlet,
		meta: {
			...requireAuth,
			accessKey: "outletWorkshop"
		}
	},
	{
		path: "/AddOutlet/:idoutlet/:submodule/:action/:id",
		name: "addoutletwithaction",
		component: AddOutlet,
		meta: {
			...requireAuth,
			accessKey: "outletWorkshop"
		}
	},
	{
		path: "/AddOutlet/:idoutlet/:submodule/:idLayanan",
		name: "editLayananOutlet",
		component: AddOutlet,
		meta: {
			...requireAuth,
			accessKey: "outletWorkshop"
		}
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		component: Dashboard,
		meta: requireAuth
	},
	{
		path: '/dashboard/:data',
		name: 'datadashboard',
		component: DataDashboard,
		meta: requireAuth
	},
	{
		path: '/detailoutlet/:idoutlet',
		name: 'detailoutlet',
		component: DetailOutlet,
		meta: requireAuth
	},
	{
		path: '/detailoutletnonaktif/:idoutlet',
		name: 'detailoutletnonaktif',
		component: DetailOutletNonaktif,
		meta: requireAuth
	},
	{
		path: '/setproduction',
		name: 'setproduction',
		component: SetProduction,
		meta: requireAuth
	},
	{
		path: '/detailworkshopproduksi/:idworkshop',
		name: 'DetailWorkshopSetprod',
		component: DetailWorkshopSetprod,
		meta: requireAuth
	},
	{
		path: '/tahapansetproduksi/:idworkshop',
		name: 'TahapanSetProduksi',
		component: TahapanSetProduksi,
		meta: requireAuth
	},
	{
		path: '/dataworkshopproduksi/:idworkshop',
		name: 'DataWorkshopProduksi',
		component: DataWorkshopProduksi,
		meta: requireAuth
	},

	{
		path: '/createtahapansetprod/:idworkshop',
		name: 'CreateTahapanSetProd',
		component: CreateTahapanSetProd,
		meta: requireAuth
	},

	{
		path: '/tahapandetailsetprod',
		name: 'TahapanDetailSetProd',
		component: TahapanDetailSetProd,
		meta: requireAuth
	},

	{
		path: '/workshop',
		name: 'dataworkshop',
		component: DataWorkshop,
		meta: requireAuth
	},
	{
		path: '/productionworkshop',
		name: 'productionworkshop',
		component: ProductionWorkshop,
		meta: requireAuth
	},
	{
		path: '/detailworkshop/:idworkshop',
		name: 'detailworkshop',
		component: DetailWorkshop,
		meta: requireAuth
	},

	{
		path: '/detailworkshopnonaktif/:idworkshop',
		name: 'detailworkshopnonaktif',
		component: DetailWorkshopNonaktif,
		meta: requireAuth
	},

	{
		path: '/rak/:idoutlet',
		name: 'datarak',
		component: DataRak,
		meta: requireAuth
	},
	{
		path: '/createrak',
		name: 'CreateRak',
		component: CreateRak,
		meta: requireAuth
	},
	{
		path: '/editrak/:idoutlet',
		name: 'EditRak',
		component: EditRak,
		meta: requireAuth
	},
	{
		path: '/detailraak/:idoutlet',
		name: 'DetailRak',
		component: DetailRak,
		meta: requireAuth
	},

	{
		path: '/setrak',
		name: 'SetRak',
		component: SetRak,
		meta: requireAuth
	},

	{
		path: '/perfume/:idoutlet',
		name: 'dataperfume',
		component: DataPerfume,
		meta: requireAuth
	},
	{
		path: '/pajak/:idoutlet',
		name: 'taxsetting',
		component: TaxSetting,
		meta: requireAuth
	},
	{
		path: '/nota/:idoutlet',
		name: 'nota',
		component: Nota,
		meta: requireAuth
	},
	{
		path: '/notatext/:idoutlet/:type',
		name: 'notatext',
		component: NotaText,
		meta: requireAuth
	},

	{
		path: '/setnota',
		name: 'setnota',
		component: SetNota,
		meta: requireAuth
	},

	{
		path: '/layanan/:idoutlet',
		name: 'layanan',
		component: Layanan,
		meta: requireAuth
	},
	{
		path: '/tambahlayanan/:idoutlet',
		name: 'tambahlayanan',
		component: TambahLayanan,
		meta: requireAuth
	},

	{
		path: '/editlayanan/:idoutlet/:idlayanan',
		name: 'editlayanan',
		component: EditLayanan,
		meta: requireAuth
	},

	{
		path: '/setservice',
		name: 'PengaturanLayanan',
		component: PengaturanLayanan,
		meta: requireAuth
	},

	{
		path: '/snapservice/:idoutlet',
		name: 'snapservice',
		component: SnapService,
		meta: requireAuth
	},
	{
		path: '/snapcreate/:idoutlet',
		name: 'snapcreate',
		component: SnapCreate,
		meta: requireAuth
	},
	{
		path: '/snapedit/:idoutlet/:idsnap',
		name: 'snapedit',
		component: SnapEdit,
		meta: requireAuth
	},
	{
		path: '/setsnapservice',
		name: 'SetSnapService',
		component: SetSnapService,
		meta: requireAuth
	},
	{
		path: '/deposit/:idoutlet',
		name: 'deposit',
		component: Deposit,
		meta: requireAuth
	},
	{
		path: '/addeposit/:idoutlet',
		name: 'tambahdeposit',
		component: TambahDeposit,
		meta: requireAuth
	},
	{
		path: '/editdeposit/:idoutlet/:iddeposit',
		name: 'editdeposit',
		component: EditDeposit,
		meta: requireAuth
	},
	{
		path: '/setdeposit',
		name: 'SetDeposit',
		component: SetDeposit,
		meta: requireAuth
	},
	{
		path: '/epaymentlist/:idoutlet/',
		name: 'epaymentlist',
		component: EpaymentList,
		meta: requireAuth
	},
	{
		path: '/epaymentcreate/:idoutlet',
		name: 'epaymentcreate',
		component: EpaymentCreate,
		meta: requireAuth
	},
	{
		path: '/epaymentedit/:idoutlet/:idpayment',
		name: 'epaymentedit',
		component: EpaymentEdit,
		meta: requireAuth
	},
	{
		path: '/setepayment',
		name: 'SetEpayment',
		component: SetEpayment,
		meta: requireAuth
	},
	{
		path: '/addworkshop',
		name: 'addworkshop',
		component: AddWorkshop,
		meta: requireAuth
	},
	{
		path: '/tahapanworkshop/:idworkshop',
		name: 'settahapanworkshop',
		component: SetTahapanWorkshop,
		meta: requireAuth
	},
	{
		path: '/karyawanlist',
		name: 'karyawanlist',
		component: KaryawanList,
		meta: requireAuth
	},

	{
		path: '/createstaff',
		name: 'createstaff',
		component: CreateStaff,
		meta: requireAuth
	},
	{
		path: '/datastaff',
		name: 'datastaff',
		component: DataStaff,
		meta: requireAuth
	},

	{
		path: '/datapekerjaan',
		name: 'datapekerjaan',
		component: DataPekerjaan,
		meta: requireAuth
	},
	{
		path: '/datagaji',
		name: 'datagaji',
		component: DataGaji,
		meta: requireAuth
	},
	{
		path: '/karyawan',
		name: 'karyawan',
		component: Karyawan,
		meta: {
			...requireAuth,
			accessKey: 'employees'
		}
	},

	{
		path: '/detailkaryawan/:idkaryawan',
		name: 'detailkaryawan',
		component: DetailKaryawan,
		meta: requireAuth
	},

	{
		path: '/workset/:idkaryawan',
		name: 'workset',
		component: WorkSet,
		meta: requireAuth
	},

	{
		path: '/akunset/:idkaryawan',
		name: 'akunset',
		component: AkunSet,
		meta: requireAuth
	},
	{
		path: '/salesset/:idkaryawan',
		name: 'salesset',
		component: SalesSet,
		meta: requireAuth
	},
	{
		path: '/sallaryset/:idkaryawan',
		name: 'sallaryset',
		component: SallarySet,
		meta: requireAuth
	},
	{
		path: '/categorysallary/:idkaryawan',
		name: 'categorysallary',
		component: CategorySallary,
		meta: requireAuth
	},

	{
		path: '/activationcommision/:idkaryawan',
		name: 'activationcommision',
		component: ActivationCommision,
		meta: requireAuth
	},

	{
		path: '/listcommision',
		name: 'listcommision',
		component: ListCommision,
		meta: requireAuth
	},

	{
		path: '/createcommision',
		name: 'createcommision',
		component: CreateCommision,
		meta: requireAuth
	},

	{
		path: '/logoutpage/:idkaryawan',
		name: 'logoutpage',
		component: LogouPage,
		meta: requireAuth
	},

	{
		path: '/detailakunowner',
		name: 'detailakunowner',
		component: DetailAkun,
		meta: {
			...requireAuth,
			accessKey: 'account.read'
		}
	},
	{
		path: '/loginownerwa',
		name: 'loginownerwa',
		component: LoginOwnerWA,
		meta: requireAuth
	},
	{
		path: '/debugapp',
		name: 'debugapp',
		component: DebugApp,
		meta: requireAuth
	},
	{
		path: '/session',
		name: 'session',
		component: ActiveSession,
		meta: requireAuth,
	},

	{
		path: '/loginowneremail',
		name: 'loginowneremail',
		component: LoginOwnerEmail,
		meta: requireAuth
	},
	{
		path: '/setemailowner',
		name: 'setowneremail',
		component: SetEmailOwner,
		meta: requireAuth
	},

	{
		path: '/nomorlama',
		name: 'verifikasinomorlama',
		component: VerifikasiNomorLama,
		meta: requireAuth
	},

	{
		path: '/verifikasinomorbaru',
		name: 'verifikasinomorbaru',
		component: VerifikasiNomorBaru,
		meta: requireAuth
	},

	{
		path: '/successchangewa',
		name: 'successchangewa',
		component: SuccessChangeWA,
		meta: requireAuth
	},

	{
		path: '/editemail',
		name: 'editemail',
		component: EditEmail,
		meta: requireAuth
	},

	{
		path: '/successchangeemail/:email',
		name: 'successchangeemail',
		component: SuccessChangeEmail,
		meta: requireAuth
	},

	{
		path: '/verifikasiemail/:code',
		name: 'verifikasiemail',
		component: VerifikasiEmail,
		meta: localStorage.getItem("token") !== null ? requireAuth : null
	},

	{
		path: '/createpassword',
		name: 'createpassword',
		component: CreatePassword,
		meta: requireAuth
	},

	{
		path: '/successchangepassword',
		name: 'successchangepassword',
		component: SuccessChangePassword,
		meta: requireAuth
	},

	{
		path: '/pusatbantuan',
		name: 'pusatbantuan',
		component: PusatBantuan,
		meta: requireAuth
	},

	{
		path: '/addpenggajian',
		name: 'AddPenggajian',
		component: AddPenggajian,
		meta: requireAuth
	},

	{
		path: '/penggajian',
		name: 'penggajian',
		component: Penggajian,
		meta: requireAuth
	},

	{
		path: '/bayargaji',
		name: 'bayargaji',
		component: BayarGaji,
		meta: requireAuth
	},

	{
		path: '/fakturgaji',
		name: 'fakturgaji',
		component: FakturGaji,
		meta: requireAuth
	},

	{
		path: '/listtanggungan',
		name: 'listtanggungan',
		component: ListTanggungan,
		meta: requireAuth
	},

	{
		path: '/detailkehadiran',
		name: 'detailkehadiran',
		component: DetailKehadiran,
		meta: requireAuth
	},

	{
		path: '/ubahabsensi',
		name: 'ubahabsensi',
		component: UbahAbsensi,
		meta: requireAuth
	},

	{
		path: '/previewgaji',
		name: 'previewgaji',
		component: PreviewGaji,
		meta: requireAuth
	},

	{
		path: '/detailpembayaran',
		name: 'detailpembayaran',
		component: DetailPembayaran,
		meta: requireAuth
	},

	{
		path: '/riwayatpembayaran',
		name: 'riwayatpembayaran',
		component: RiwayatPembayaran,
		meta: requireAuth
	},

	{
		path: '/addkasbon',
		name: 'addkasbon',
		component: AddKasbon,
		meta: requireAuth
	},

	{
		path: '/listkasbon',
		name: 'listkasbon',
		component: ListKasbon,
		meta: requireAuth
	},

	{
		path: '/tambahkasbon',
		name: 'tambahkasbon',
		component: TambahKasbon,
		meta: requireAuth
	},

	{
		path: '/bayarkasbon',
		name: 'bayarkasbon',
		component: BayarKasbon,
		meta: requireAuth
	},

	{
		path: '/detailkasbon',
		name: 'detailkasbon',
		component: DetailKasbon,
		meta: requireAuth
	},

	{
		path: '/addpotongan',
		name: 'addpotongan',
		component: AddPotongan,
		meta: requireAuth
	},

	{
		path: '/listpotongan',
		name: 'listpotongan',
		component: ListPotongan,
		meta: requireAuth
	},

	{
		path: '/tambahpotonganx',
		name: 'tambahpotonganx',
		component: TambahPotonganx,
		meta: requireAuth
	},

	{
		path: '/bayarpotonganx',
		name: 'bayarpotonganx',
		component: BayarPotonganx,
		meta: requireAuth
	},

	{
		path: '/riwayatcicilkasbon',
		name: 'riwayatcicilkasbon',
		component: RiwayatCicilKasbon,
		meta: requireAuth
	},

	{
		path: '/riwayatcicilpotongan',
		name: 'riwayatcicilpotongan',
		component: RiwayatCicilPotongan,
		meta: requireAuth
	},

	{
		path: '/detailpotonganx',
		name: 'detailpotonganx',
		component: DetailPotonganx,
		meta: requireAuth
	},

	{
		path: '/detailpotongancicilx',
		name: 'detailpotongancicilx',
		component: DetailPotonganCicilx,
		meta: requireAuth
	},

	{
		path: '/addkomisisallary',
		name: 'addkomisip',
		component: AddKomisiP,
		meta: requireAuth
	},

	{
		path: '/listkomisix',
		name: 'listkomisix',
		component: ListKomisix,
		meta: requireAuth
	},

	{
		path: '/createkomisi',
		name: 'createkomisi',
		component: CreateKomisi,
		meta: requireAuth
	},

	{
		path: '/editkomisix',
		name: 'editkomisix',
		component: EditKomisix,
		meta: requireAuth
	},

	{
		path: '/inputlayanansnap',
		name: 'inputlayanansnap',
		component: InputLayananSnap,
		meta: requireAuth
	},

	{
		path: '/rekapabsen',
		name: 'rekapabsen',
		component: RekapAbsen,
		meta: requireAuth
	},

	{
		path: '/detailabsen',
		name: 'detailabsen',
		component: DetailAbsen,
		meta: requireAuth
	},

	{
		path: '/imporabsen',
		name: 'imporabsen',
		component: ImporAbsen,
		meta: requireAuth
	},

	{
		path: '/periodeabsen',
		name: 'periodeabsen',
		component: PeriodeAbsen,
		meta: requireAuth
	},

	{
		path: '/dashboard/:notification',
		name: 'notification',
		component: Notification,
		meta: requireAuth
	},
	{
		path: '/ibos',
		name: 'ibos',
		component: Ibos,
		meta: requireAuth
	},
	{
		path: "/datakuy",
		name: "datakuy",
		component: Backup2020,
		meta: requireAuth
	},
	{
		path: "/backup-layanankuy",
		name: "backup-layanankuy",
		component: backupLayanan,
		meta: requireAuth
	},
	{
		path: "/backup-depositkuy",
		name: "backup-depositkuy",
		component: backupDeposit,
		meta: requireAuth
	},
	/* Notifikasi (sementara statis)*/
	{
		path: "/broadcast",
		name: "broadcast",
		component: Broadcast,
		meta: requireAuth
	},
	{
		path: "/kilasbalik",
		name: "kilasbalik",
		component: Rewind,
		meta: requireAuth
	},

	{
		path: '/subscribe/:telp',
		name: 'subscribe',
		component: SubscribeOwner,
		meta: notRequireAuth
	},
	{
		path: '/about',
		name: 'about',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	},

	{
		path: '/playground/input',
		name: "PlaygroundInput",
		component: PlaygroundInput,
		meta: requireAuth,
	}
]

const saveToLocal = (url) => {
	localStorage.setItem("token", url.searchParams.get('token'));
	localStorage.setItem("email", url.searchParams.get('email'));
	localStorage.setItem("idowner", url.searchParams.get('idowner'));
	let incontext = []
	incontext.push(url.searchParams.get('idowner'))
	localStorage.setItem("incontext-device", JSON.stringify(incontext));
	localStorage.setItem("step_walkthrough", "3");
	const config = {
		apiBase: url.searchParams.get('api_base'),
		platform: url.searchParams.get('platform'),
		webBase: url.searchParams.get('web_base'),
		userType: url.searchParams.get('user_type'),
		idKaryawan: url.searchParams.get('idkaryawan'),
		isWebview: url.searchParams.get('is_webview'),
		wl: url.searchParams.get('wl'),
	}
	localStorage.setItem('flutterConfig', JSON.stringify(config));
}

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
		if (to.path !== from.path) {
			return { x: 0, y: 0 }
		}
	},
	routes
})
router.beforeEach(async (to, from, next) => {
	const url = new URL(window.location.href);
	const localWebview = localStorage.getItem('isWebview') ?? false
	const localWhitelabel = JSON.parse(localStorage.getItem('isWhitelabel')) ?? false
	if (url.searchParams.get('token') || localWebview) {
		const isWebview = url.searchParams.get('is_webview') == 1 || localWebview
		const isWhitelabel = url.searchParams.get('wl') == 1 || localWhitelabel
		localStorage.setItem('isWebview', isWebview.toString());
		localStorage.setItem('isWhitelabel', isWhitelabel.toString());
		store.commit('metaModule/setIsWebview', JSON.parse(localStorage.getItem('isWebview')))
		if (store.state.metaModule.isWhitelabel == null || url.searchParams.get('wl') != undefined) {
			store.commit('metaModule/setIswhitelabel', url.searchParams.get('wl') == 1)
		}
		if (isWebview) {
			if (url.searchParams.get('token')) {
				saveToLocal(url)
			}

			const config = JSON.parse(localStorage.getItem('flutterConfig'));
			
			Vue.prototype.$baseurl = config.apiBase;
			if (config.userType === 'employee') {
				axios.get(config.apiBase + '/auth/get_acl_user_roles', {
					params: {
						idkaryawan: config.idKaryawan
					}
				}).then(res => {
					const acl_list = res.data.data.idacl_master
					localStorage.setItem('acl_list', JSON.stringify(res.data.data.idacl_master));
					store.commit('metaModule/setAclList', acl_list)
				})
			}
			else {
				store.commit('metaModule/setAclList', 'owner')
			}
		}
		else {
			localStorage.setItem('email', url.searchParams.get('email'));
			localStorage.setItem('token', url.searchParams.get('token'));
			localStorage.setItem('idowner', url.searchParams.get('idowner'));
		}
	}
	if (localWebview) {
		settingFlutterConfigAndAcl(localWebview, url)
		store.commit('metaModule/setIsWebview', localWebview)
	}
	if (to.meta.hasOwnProperty('accessKey') && store.state.metaModule.isWebview) {
		// kalau owner langsung los
		if (store.state.metaModule.aclList == 'owner') {
			next();
			return
		}
		//kalau bukan owner cek dulu aclnya
		else {
			const aclList = store.state.metaModule.aclList
			if (aclList.length) {
				if (!aclList.includes(to.meta.accessKey)) {
					process.env.NODE_ENV !== "production" && console.log('no access to route ' + to.name);
					return false;
				}
			}
			const acl = JSON.parse(localStorage.getItem('acl_list'));
			store.commit('metaModule/setAclList', acl)	
		}
	}
	next();
})

const settingFlutterConfigAndAcl = async (localWebview, url) => {
	const config = localWebview ? JSON.parse(localStorage.getItem('flutterConfig')) : {
		apiBase: url.searchParams.get('api_base'),
		platform: url.searchParams.get('platform'),
		webBase: url.searchParams.get('web_base'),
		userType: url.searchParams.get('user_type'),
		idKaryawan: url.searchParams.get('idkaryawan'),
	}
	Vue.prototype.$baseurl = config.apiBase;
	if (!localWebview) {
		localStorage.setItem('flutterConfig', JSON.stringify(config));
	}

	const userType = localWebview ? config.userType : url.searchParams.get('user_type')
	if (userType === 'employee') {
		if(localStorage.getItem('acl_list') == null) {
			const res = await axios.get(config.apiBase + '/auth/get_acl_user_roles', {
				params: {
					idkaryawan: url.searchParams.get('idkaryawan')
				}
			})
			localStorage.setItem('acl_list', JSON.stringify(res.data.data.idacl_master));
		}
		let acl_list = JSON.parse(localStorage.getItem('acl_list'));
		store.commit('metaModule/setAclList', acl_list)
	}
	else {
		store.commit('metaModule/setAclList', 'owner')
	}
}
export default router